import { isServer, QueryClient } from '@tanstack/react-query';
import { queryClientConfig } from 'src/dal/config/queryClientConfig';

function makeQueryClient() {
  return new QueryClient(queryClientConfig);
}

let browserQueryClient: QueryClient | undefined;

export function getQueryClient() {
  if (isServer) {
    return makeQueryClient();
  }

  // В браузере переиспользуем один QueryClient между рендерами: иначе React при
  // suspense на первом рендере пересоздаст клиент и потеряет кэш. Не требуется,
  // если Suspense-boundary находится ниже места создания клиента.
  if (!browserQueryClient) browserQueryClient = makeQueryClient();

  return browserQueryClient;
}
